import { call, put, select } from 'redux-saga/effects';
import { User, UserId } from 'features/users/types';
import { selectLocalUserId, selectUserById } from 'features/users/usersSlice';
import { logger } from 'utils/logger';
import {
  broadcastPermissionGranted,
  signalingBroadcastAllowed,
} from 'features/permissions/actions';
import { updateOrderSaga } from 'features/layout/sagas/updateOrderSaga';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';

export function* onBroadcastAllowedSaga({ payload }: ReturnType<typeof signalingBroadcastAllowed>) {
  const { data, initiator } = payload;

  const localUserId: UserId = yield select(selectLocalUserId);

  const remoteUserIds: UserId[] = [];

  for (const user of data.users) {
    if (localUserId === user.id) {
      logger
        .remote({ tier: 1 })
        .info(`The user was allowed to broadcast by user id=${initiator.id}`);

      const initiatorUser: User | undefined = yield select(selectUserById, initiator.id);

      yield call(
        notification,
        initiatorUser?.name
          ? i18n.t('notifications:broadcast_allowed', { username: initiatorUser.name })
          : i18n.t('notifications:broadcast_allowed_unnamed')
      );

      yield put(
        broadcastPermissionGranted({
          id: user.id,
          audio: user.audio,
          video: user.video,
          initiator,
        })
      );
    } else {
      remoteUserIds.push(user.id);
    }
  }

  if (remoteUserIds.length > 0) {
    yield call(updateOrderSaga, remoteUserIds);
  }
}
